<div class="container">
    <div class="row">
        <div class="col-12">
            <h3>ข้อมูลทำรายการ</h3>
            <table class="table">
                <thead>
                    <tr class="d-none d-md-table-row">
                        <th>สถานะ</th>
                        <th>วันที่เวลา</th>
                        <th>ชื่อลูกค้า</th>
                        <th class="d-none d-lg-table-cell">จำนวนเงิน</th>
                        <th class="text-lg-start text-end">คะแนน</th>
                        <th class="text-end d-none d-lg-table-cell">ผู้ทำรายการ</th>

                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let tsc of TransactionItems">
                        <tr class="d-none d-md-table-row">
                            <td>{{tsc.Descriptions}}</td>
                            <td>{{tsc.Transaction_time | date:'dd/MM/yyyy HH:mm':'UTC'}}</td>
                            <td>{{tsc.Member_name}}</td>
                            <td class="d-none d-lg-table-cell">{{tsc.Amount | number:'1.2-2'}}</td>
                            <td class="text-lg-start text-end">{{tsc.Point}}</td>
                            <td class="text-end d-none d-lg-table-cell">{{tsc.Employee}}</td>
                        </tr>
                        <tr class="d-md-none d-table-row">
                            <td>
                                <div class="row">
                                    <div class="col-8">
                                        {{tsc.Descriptions}}
                                        <br>
                                        {{tsc.Transaction_time | date:'dd/MM/yyyy HH:mm':'UTC'}}
                                    </div>
                                    <div class="col-4 text-end">
                                        {{tsc.Member_name}}
                                        <br>
                                        {{tsc.Point}}
                                        <br>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <span>ผู้ทำรายการ : {{tsc.Employee}}</span>
                                    </div>
                                </div>

                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
            <app-pagination *ngIf="TransactionItems" [page]="1" [pageTotal]="pageTotal"
                (updatePage)="getTransaction($event)"></app-pagination>
        </div>
    </div>
</div>